"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmClose = void 0;
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const confirmClose = ({ changeEvent = 'onChange' } = {}) => (Component) => {
    return props => {
        const [isDirty, setIsDirty] = (0, react_1.useState)(false);
        let justChanged = false; // TODO: Is this the proper way to handle this with useState?
        const onChange = (...args) => {
            setIsDirty(false);
            justChanged = true;
            if (props.onClean)
                props.onClean();
            const changeHandler = props[changeEvent];
            changeHandler(...args);
        };
        const onClose = () => {
            if (isDirty && !justChanged) {
                antd_1.Modal.confirm({
                    title: 'You have unsaved changes.',
                    content: 'You will lose them if you continue. Are you sure you want to close this?',
                    onCancel: props.onClose,
                    cancelButtonProps: { danger: true },
                    width: 650,
                    okText: 'Go Back & Keep Changes',
                    cancelText: 'Continue Without Saving',
                });
            }
            else {
                props.onClose();
            }
        };
        const wrappedProps = Object.assign(Object.assign({}, props), { [changeEvent]: onChange, onClose, onDirty: () => {
                setIsDirty(true);
                if (props.onDirty)
                    props.onDirty();
            } });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_router_dom_1.Prompt, { when: isDirty, message: 'You will lose them if you continue. Are you sure you want to close this?' }),
            react_1.default.createElement(Component, Object.assign({}, wrappedProps))));
    };
};
exports.confirmClose = confirmClose;
//# sourceMappingURL=ConfirmClose.js.map